import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useState } from 'react';

export const Header = ({ roundName, matchData, matchID }) => {
    const [roundTitle, setRoundTitle] = useState(roundName);

    useEffect(() => {
        setRoundTitle(
            `${roundName}${
                matchID && matchData
                    ? ` - ${matchData.home?.team?.name} v ${matchData.away?.team?.name}`
                    : ''
            }`
        );
    }, [roundName, matchData, matchID]);

    return (
        <header className="video-hub-video-listing__header js-round-header">
            <h2 className="video-hub-video-listing__title">{roundTitle}</h2>
        </header>
    );
};

Header.propTypes = {
    roundName: PropTypes.string,
    matchData: PropTypes.object,
    matchID: PropTypes.any
};
